export default {"src":"/_next/static/media/arrow-back.8591b19d.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};